module.exports = __webpack_public_path__ + "media/מספריים.67b4beea.mp3";